import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSportTicketListAPI } from "../../apiConfig/apiCall";

export const getSportTicketList = createAsyncThunk('getSportTicketList', async () => {
    const response = await getSportTicketListAPI();
    return response.data;
});